export const sliderContainerStyle = (cssClasses: string = ''): string =>
  `pl-5 pr-5 ${cssClasses}`

export const SliderStyles = {
  slider: 'lcpq-slider bg-transparent',
}
